const Footer = () => {
  return (
    <footer className="w-full text-center py-3 text-black text-sm mt-auto">
      <p className="m-0 tracking-wide">
        Designed and Developed By: {" "}
        <span className="font-semibold text-blue-700">VRSamadhan Tech Solution</span>
      </p>
    </footer>
  );
};

export default Footer;
